<div>
  <div class="grid grid-cols-1 gap-6">
    <nz-form-item class="flex">
      <nz-form-control>
        <input
          type="text"
          nz-input
          class="w-full"
          [(ngModel)]="this.name"
          [placeholder]="'settings.shared.addEditCategories.namePlaceholder' | transloco"/>
      </nz-form-control>
    </nz-form-item>
  </div>
</div>
<div *nzModalFooter>
  <button nz-button nzType="default" (click)="handleCancel()">{{ 'settings.shared.addEditCategories.buttons.close' | transloco }}</button>
  <button nz-button nzType="primary" [nzLoading]="this.isButtonLoading" (click)="this.entryType === 'new' ? this.addNewCategory(): this.editCategory()"
          [disabled]="this.name ===''">
    {{ this.entryType === 'new' ? ('settings.shared.addEditCategories.buttons.add' | transloco) : ('settings.shared.addEditCategories.buttons.edit' | transloco) }}
  </button>
</div>
